import axios from 'axios'
import constants from '../constants'

const LOCATION_PATH = constants.urlPrefix + '/api/locations';

const getMemberLocations = () => axios.get(LOCATION_PATH);

const assignToastLocation = (data) => axios.post(LOCATION_PATH + "/assign/toast", data);
const assignPopmenuLocation = (data) => axios.post(LOCATION_PATH + "/assign/popmenu", data);
const assignTreezLocation = (data) => axios.post(LOCATION_PATH + "/assign/treez", data);
const assignSquareLocation = (data) => axios.post(LOCATION_PATH + "/assign/square", data);

export default {
    getMemberLocations,
    assignToastLocation,
    assignSquareLocation,
    assignTreezLocation,
    assignPopmenuLocation,
}
